export default {
  theme: localStorage.getItem('theme'),
  website: {},
  themes: {},
};
